module.exports = __webpack_public_path__ + "img/img3.88e31dda.svg";